import { SubscriptionActions } from '../../actions/actionTypes'
import { ApiError } from '../../Interfaces/ErrorInterfaces'
import { CouponStateInterface, ICoupon, SubscriptionInterface } from '../../Interfaces/Subscription'
import { ReducerBuilder } from '../ReducerBuilder'

type payloadType = ICoupon | ApiError | SubscriptionInterface

const initialState: CouponStateInterface = {
  loaded: false,
}

const setCoupon = (state: CouponStateInterface, payload: ICoupon): CouponStateInterface => {
  return {
    loaded: true,
    value: payload,
  }
}

const clearError = (state: CouponStateInterface, payload: ApiError): CouponStateInterface => {
  return { loaded: true, error: payload }
}

const resetCoupon = (state: CouponStateInterface): CouponStateInterface => {
  return { loaded: false }
}

const reducer = ReducerBuilder.create<CouponStateInterface, payloadType>(initialState)
  .mapAction(SubscriptionActions.COUPON.GET, setCoupon)
  .mapAction(SubscriptionActions.COUPON.FAILED, clearError)
  .mapAction(SubscriptionActions.COUPON.CLEAR, resetCoupon)
  .build()

export default reducer

// Selectors
export const getCouponFromStore = (state): CouponStateInterface => {
  return state.subscriptionManagement.coupon
}
